module.exports = __webpack_public_path__ + "static/media/AVAXL.cacd9ed1.svg";